<template>
	<v-hover v-slot:default="{ hover }">
		<v-card class="pa-6 infographic rounded-lg" flat :class="{hovering: hover}">
			<img v-bind:src="img" />
			<h3 class="cn-font text-center mb-3 mt-5">{{title}}</h3>
			<p class="grey--text text-left">{{text}}</p>
		</v-card>
	</v-hover>
</template>

<style lang="less">
	.infographic {
		border-top: 8px solid !important;
		border-top-color: transparent !important;
		background-color: transparent !important;
		height: 100%;
		width: 100%;
		text-align: center;
		cursor: pointer;
		img {
			height: 200px;
			max-height: 300px;
		}
		&.hovering { 
			background-color: white !important;
			border-top-color: #5568F1 !important;

		}
	}
</style>	
<script>
	export default {
		name: "InfographicTile", 
		props: {
			title: { type: String }, 
			text: {type: String }, 
			image: {type: String }
		},
		computed: {
			img(){
				return require (`@/assets/images/${this.image}`)
			}
		}
	}
</script>